"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EStartPlayerFailure = exports.EWeekDays = exports.EInAppNotificationType = exports.EMediafileCacheState = exports.EAdditionalFeatureType = exports.EPlayState = void 0;
var EPlayState;
(function (EPlayState) {
    EPlayState["PLAY"] = "play";
    EPlayState["PAUSE"] = "pause";
    EPlayState["STOP"] = "stop";
})(EPlayState = exports.EPlayState || (exports.EPlayState = {}));
var EAdditionalFeatureType;
(function (EAdditionalFeatureType) {
    EAdditionalFeatureType["DISABLE_CONTROLS"] = "disable_control_elements";
    EAdditionalFeatureType["DISABLE_DISLIKES"] = "disable_dislikes";
    EAdditionalFeatureType["NO_GUI_MODE"] = "no_gui_mode";
    EAdditionalFeatureType["PERIODIC_RESTART"] = "periodic_restart";
    EAdditionalFeatureType["REMOTE_CONTROL"] = "remote_control";
})(EAdditionalFeatureType = exports.EAdditionalFeatureType || (exports.EAdditionalFeatureType = {}));
var EMediafileCacheState;
(function (EMediafileCacheState) {
    EMediafileCacheState[EMediafileCacheState["NO_CACHE"] = 0] = "NO_CACHE";
    EMediafileCacheState[EMediafileCacheState["DOWNLOADING"] = 1] = "DOWNLOADING";
    EMediafileCacheState[EMediafileCacheState["CACHE"] = 2] = "CACHE";
    EMediafileCacheState[EMediafileCacheState["REQUIRES_VALIDATION"] = 3] = "REQUIRES_VALIDATION";
})(EMediafileCacheState = exports.EMediafileCacheState || (exports.EMediafileCacheState = {}));
var EInAppNotificationType;
(function (EInAppNotificationType) {
    EInAppNotificationType[EInAppNotificationType["INFO"] = 0] = "INFO";
    EInAppNotificationType[EInAppNotificationType["ERROR"] = 1] = "ERROR";
    EInAppNotificationType[EInAppNotificationType["DIALOG"] = 2] = "DIALOG";
})(EInAppNotificationType = exports.EInAppNotificationType || (exports.EInAppNotificationType = {}));
var EWeekDays;
(function (EWeekDays) {
    EWeekDays[EWeekDays["MONDAY"] = 0] = "MONDAY";
    EWeekDays[EWeekDays["TUESDAY"] = 1] = "TUESDAY";
    EWeekDays[EWeekDays["WEDNESDAY"] = 2] = "WEDNESDAY";
    EWeekDays[EWeekDays["THURSDAY"] = 3] = "THURSDAY";
    EWeekDays[EWeekDays["FRIDAY"] = 4] = "FRIDAY";
    EWeekDays[EWeekDays["SATURDAY"] = 5] = "SATURDAY";
    EWeekDays[EWeekDays["SUNDAY"] = 6] = "SUNDAY";
})(EWeekDays = exports.EWeekDays || (exports.EWeekDays = {}));
var EStartPlayerFailure;
(function (EStartPlayerFailure) {
    EStartPlayerFailure["POINT_DISABLED"] = "POINT_DISABLED";
    EStartPlayerFailure["PLAYER_SLEEPING"] = "PLAYER_SLEEPING";
})(EStartPlayerFailure = exports.EStartPlayerFailure || (exports.EStartPlayerFailure = {}));
//# sourceMappingURL=types.js.map